var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3982 23.2262C11.2729 23.4672 11.2916 23.7568 11.4463 23.9793L18.9256 34.7013C19.0618 34.8956 19.2851 35.0123 19.5225 35.0123C19.7599 35.0123 19.9832 34.8956 20.1194 34.7013L27.5986 23.9793C27.7534 23.7568 27.772 23.4672 27.6467 23.2262C27.5215 22.9861 27.2727 22.8354 27.0017 22.8354H23.4289C21.6627 11.6486 12.7318 2.70316 1.50233 0.971931C1.1047 0.908821 0.733847 1.18299 0.672568 1.58018C0.611742 1.97733 0.883639 2.34864 1.28082 2.40992C12.0868 4.07581 20.6391 12.8133 22.0785 23.6588C22.1262 24.0206 22.4348 24.2907 22.7993 24.2907H25.6073L19.5225 33.0132L13.4377 24.2907H16.2456C16.6474 24.2907 16.9728 23.9652 16.9728 23.5631C16.9728 16.9254 14.0922 10.6241 9.07008 6.27598C8.76595 6.01224 8.30704 6.04627 8.04422 6.34949C7.78095 6.65321 7.81409 7.11256 8.11775 7.37537C12.6365 11.2882 15.3038 16.8891 15.5058 22.8354H12.0432C11.7723 22.8354 11.5235 22.9861 11.3982 23.2262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.3f5d887d812dc2b051363babfaf1bef6.svg";
export { ForwardRef as ReactComponent };